import { BaseUIService } from '/@/modules/core/ui/services/BaseUIService';
import { EstateDetailsShowConfig } from '@/modules/core/ui/models/EstateDetailsShowConfig';
import type { CustomRouter } from '@/types/router.types';
import { OpsEstateRoute } from '@/modules/ops/constants/OpsEstateRoute';
import ApiService from '@/modules/core/api/services/ApiService';
import OpsDetailsRouteService from '@/modules/ops/services/OpsDetailsRouteService';
import { EstateDetailsCloseConfig } from '@/modules/core/ui/models/EstateDetailsCloseConfig';

export class EstateDetailsService extends BaseUIService {
  async show(config: EstateDetailsShowConfig): Promise<void> {
    const router: CustomRouter = config.component.$router;
    const query: Params = {};

    if (config.tab) {
      query.tab = config.tab;
    }

    await router.push({
      name: OpsEstateRoute.DETAILS.name,
      params: { id: config.modelId.toString() },
      query
    });
  }

  async close(config: EstateDetailsCloseConfig): Promise<void> {
    const router: CustomRouter = config.component.$router;

    ApiService.cancelPendingGetRequests();
    const name: string = OpsDetailsRouteService.getRedirectRoute(router, config.estate);

    await router.push({ name, query: {} });
  }
}

export default new EstateDetailsService();
